import { render } from "./GenderStructure.vue?vue&type=template&id=45b8d894"
import script from "./GenderStructure.vue?vue&type=script&lang=js"
export * from "./GenderStructure.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__